// extracted by mini-css-extract-plugin
export var divider = "_23-0";
export var dividerText = "_23-1";